"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.form.language.label': '语言',
    'user.form.language.placeholder': '选择语言',
    'user.form.userGroup.label': '用户组',
    'user.form.userGroup.placeholder': '选择用户组',
    'user.form.userGroup.show': '显示用户组',
    'user.form.userGroup.add': '添加新用户组',
    'user.form.userGroup.search_placeholder': '搜索用户组...',
    'user.form.title.edit': '编辑用户',
    'user.form.title.add': '添加用户',
    'user.form.back': '返回',
    'user.form.name.label': '名字',
    'user.form.name.placeholder': '三',
    'user.form.last_name.label': '姓氏',
    'user.form.last_name.placeholder': '张',
    'user.form.username.label': '登录',
    'user.form.username.placeholder': 'zhangsan',
    'user.form.email.label': '电子邮件',
    'user.form.email.placeholder': 'email@地址.com',
    'user.form.password.label': '密码',
    'user.form.password.new.label': '新密码（留空保持当前密码）',
    'user.form.password.placeholder': '密码',
    'user.form.password.repeat.label': '重复密码',
    'user.form.password.repeat.new.label': '重复密码（留空保持当前密码）',
    'user.form.password.repeat.placeholder': '重复密码',
    'user.form.role.label': '角色',
    'user.form.role.placeholder': '选择角色',
    'user.form.active.label': '活跃',
    'user.form.companies.label': '分配的公司',
    'user.form.companies.placeholder': '选择公司',
    'user.form.company.label': '公司',
    'user.form.company.placeholder': '选择公司...',
    'user.form.submit.update': '更新用户',
    'user.form.submit.create': '创建用户',
    'user.form.acl.loadError': '加载ACL元数据失败：',
    'user.form.load.debug': '加载用户：',
    'user.form.load.error': '加载用户失败',
    'user.form.submit.updateError': '更新用户失败',
    'user.form.submit.createError': '创建用户失败',
    'user.form.submit.updateSuccess': '用户更新成功',
    'user.form.submit.createSuccess': '用户创建成功',
    'user.form.preview.title': '访问预览',
    'user.form.preview.selectedGroup': '所选组',
    'user.form.preview.permissions': '权限',
    'user.form.preview.selectGroup': '选择用户组以预览访问权限',
    'user.form.preview.noAccess': '没有可用的访问权限',
    'user.form.error.userGroup_required': '必须选择用户组',
};
